var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-contact-mobile"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.08,
    y: 1.75,
    width: 11.87,
    height: 20.37,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.37,
    y: 17.13,
    width: 1.29,
    height: 1.29,
    rx: 0.64
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSvg);
export default __webpack_public_path__ + "static/media/contact-svg.55c26ab04398b2769a60af3f26fcc60d.svg";
export { ForwardRef as ReactComponent };